import React, { useState, useEffect } from 'react'
import { Popover, Typography } from '@mui/material'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { RiChatHistoryLine } from 'react-icons/ri'
import { LuCalendarDays } from 'react-icons/lu'
import CustomDisputeRiskTable from '../../Common/ui/riskTable'
import { useRiskStore } from './Store/RiskStore'
import Loading from '../../Common/ui/Loading'
import * as RiskTypes from '../../Entities/RiskTypes'
import { useLocation } from 'react-router'

const RejectedRisk = () => {
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const { riskDetailsLoading, tableBodyData, getRiskDetails } = useRiskStore()
    const location = useLocation()
    const riskOwn = location?.state?.riskType

    const loginId = localStorage.getItem('userId')
    useEffect(() => {
        if (riskOwn) {
            getRiskDetails(1, 30, riskOwn, 5, loginId)
        }
    }, [ riskOwn, location ])

    const openModal = () => {
        setIsModalOpen(true)
    }
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }

    const TableHeaders = RiskTypes?.DISPUTE_TABLE_HEADERS?.map((mapData) => {
        if (mapData?.field === RiskTypes.DOT) {
            return {
                ...mapData,
                renderCell: (params) => (
                    <div>
                        <BsThreeDotsVertical onClick={openModal} className='mt-3 '/>
                    </div>
                )
            }
        } else return mapData
    })

    return (
        <div className='h-[100%] p-6'>
            <Loading isLoading={riskDetailsLoading} />
            <CustomDisputeRiskTable tableHeaders={TableHeaders} tableBodyData={tableBodyData} />
            <Popover
                open={isModalOpen}
                onClose={toggleModal}
                className='p-2'
                anchorReference="anchorPosition"
                anchorPosition={{ top: 250, left: 1320 }}>
                {/* <div className='flex'><RiVideoAddLine className='m-3'/><Typography sx={{ p: 1 }}>Meeting </Typography></div> */}
                <div className='flex'><LuCalendarDays className='m-3'/><Typography sx={{ p: 1 }}>Set Reminder</Typography></div>
                <div className='flex'><RiChatHistoryLine className='m-3'/><Typography sx={{ p: 1 }}>Chat & Timeline </Typography></div>
            </Popover>
        </div>
    )
}

export default RejectedRisk
